function SocialYouTubeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      fill="currentcolor"
    >
      <path d="M12 0c6.63 0 12 5.37 12 12s-5.37 12-12 12S0 18.63 0 12 5.37 0 12 0zm.28 6.001h-.56c-1.073.006-4.902.047-5.971.336A2.01 2.01 0 004.334 7.76c-.297 1.117-.33 3.31-.334 3.785v.183c.004.474.037 2.668.334 3.784a2.01 2.01 0 001.415 1.424c1.105.298 5.156.332 6.068.336h.366c.912-.004 4.963-.038 6.068-.336a2.01 2.01 0 001.415-1.424C20 14.257 20 11.636 20 11.636s0-2.62-.334-3.876a2.01 2.01 0 00-1.415-1.423c-1.07-.289-4.898-.33-5.97-.336zm-1.916 3.256l4.181 2.38-4.181 2.378V9.257z" />
    </svg>
  );
}

export default SocialYouTubeIcon;
